import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { fadeInOut } from '@x/common/animations';
import { OperationInitialState, OperationObserverService } from '@x/common/operation';
import { CartOverlayService } from '@x/ecommerce-shop/app/core/order/services/cart-overlay.service';
import { RoutingContextService } from '@x/ecommerce-shop/app/core/routing/routing-context.service';
import { IShopOrder } from '@x/ecommerce/shop-client';
import { Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'x-order-bag-overlay',
  templateUrl: './order-bag-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInOut],
  host: { class: 'x-order-bag-overlay' },
})
export class OrderBagOverlayComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private actionsQ$ = this.operationService.createQueue();

  @HostBinding('@fadeInOut')
  fadeInAnimate: string;

  @Output() closeBag = new EventEmitter<void>();

  @Input() order: IShopOrder | null;

  operationQState$ = this.actionsQ$.statusChanges().pipe(
    map((status) => status.state),
    startWith(new OperationInitialState()),
  );

  buttonLoading$ = this.rc.routeTransition$;

  constructor(
    private rc: RoutingContextService,
    private operationService: OperationObserverService,
    private miniCartService: CartOverlayService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(this.actionsQ$.observe().subscribe());

    this.subscription.add(this.rc.routeTransition$.subscribe(() => this.closeBagOverlay()));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.miniCartService.closeCart();
  }

  closeBagOverlay() {
    this.closeBag.emit();
  }
}
